import TableOrdenDeDespacho from './TableOrdenDeDespacho'

export default TableOrdenDeDespacho
